export const OPEN_DIALOG = 'ContactExport_OpenDialog'
export const CLOSE_DIALOG = 'ContactExport_CloseDialog'

export const GET_SAVED_EXPORTS_REQUESTED = 'ContactExport_GetSavedExportsRequested'
export const GET_SAVED_EXPORTS_SUCCESS = 'ContactExport_GetSavedExportsSuccess'
export const GET_SAVED_EXPORTS_FAILURE = 'ContactExport_GetSavedExportsFailure'

export const GET_SEARCHES_REQUESTED = 'ContactExport_GetSearchesRequested'
export const GET_SEARCHES_SUCCESS = 'ContactExport_GetSearchesSuccess'
export const GET_SEARCHES_FAILURE = 'ContactExport_GetSearchesFailure'

export const GET_LOCATIONS_REQUESTED = 'ContactExport_GetLocationsRequested'
export const GET_LOCATIONS_SUCCESS = 'ContactExport_GetLocationsSuccess'
export const GET_LOCATIONS_FAILURE = 'ContactExport_GetLocationsFailure'

export const SAVE_CONTACT_EXPORT_REQUESTED = 'ContactExport_SaveRequested'
export const SAVE_CONTACT_EXPORT_SUCCESS = 'ContactExport_SaveSuccess'
export const SAVE_CONTACT_EXPORT_FAILURE = 'ContactExport_SaveFailure'

export const DELETE_SAVED_EXPORT_REQUESTED = 'ContactExport_DeleteRequested'
export const DELETE_SAVED_EXPORT_SUCCESS = 'ContactExport_DeleteSuccess'
export const DELETE_SAVED_EXPORT_FAILURE = 'ContactExport_DeleteFailure'

export const TAB = {
  NEW: 'NEW',
  EXISTING: 'EXISTING',
} as const

export const MEDIA_TYPE = {
  AUDIO_ONLY: 'AUDIO_ONLY',
  AUDIO_VIDEO: 'AUDIO_VIDEO',
  NONE: 'NONE',
} as const

export const MEDIA_FORMATS = [
  {
    id: 'WAV',
    name: 'WAV',
    type: MEDIA_TYPE.AUDIO_ONLY,
  },
  {
    id: 'OPUS',
    name: 'Opus',
    type: MEDIA_TYPE.AUDIO_ONLY,
  },
  {
    id: 'WEBM',
    name: 'WebM',
    type: MEDIA_TYPE.AUDIO_VIDEO,
  },
  {
    id: 'WEBM_VIDEO_VP8',
    name: 'WebM Video VP8',
    type: MEDIA_TYPE.AUDIO_VIDEO,
  },
  {
    id: 'WEBM_VIDEO_VP9',
    name: 'WebM Video VP9',
    type: MEDIA_TYPE.AUDIO_VIDEO,
  },
  {
    id: 'NONE',
    name: 'transcriptionsOnly',
    type: MEDIA_TYPE.NONE,
  },
] as const

export const ANALYTICS_OUTPUT_FORMAT = {
  NONE: 'NONE',
  JSON: 'JSON',
  XML: 'XML',
} as const

export const ANALYTICS_OUTPUT_FORMATS = Object.values(ANALYTICS_OUTPUT_FORMAT)

export const EXPORT_TYPE = {
  IMMEDIATE: 'IMMEDIATE',
  SCHEDULED: 'SCHEDULED',
} as const

export const EXPORT_FREQUENCY = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const

export const MONTH_DAYS = [
  ...Array(31)
    .fill(0)
    .map((val, i) => ++i),
]

export const WEEK_DAY = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
} as const

export const WEEK_DAYS = Object.values(WEEK_DAY)
